import {
  OPINION_CATEGORY,
  OPINION_DELETE,
  OPINION_DETAIL,
  OPINION_FILEDELETE,
  OPINION_FILEDOWNLOAD,
  OPINION_FILEINSERT,
  OPINION_INSERT,
  OPINION_LIST,
  OPINION_UPDATE,
  REISSUE_ACCESS_TOKEN
} from 'src/redux/actions/actionTypes';

let opinionData = [];

export const mainOpinionReducer = (state = opinionData, action) => {
  switch (action.type) {
    case OPINION_CATEGORY:
    case OPINION_INSERT:
    case OPINION_DETAIL:
      /* success */
      opinionData.splice(0, opinionData.length);
      if (action.payload.data === undefined) {
        return state;
      } else if (action.payload.data.resultCode === 'S0000') {
        opinionData.push(action.payload.data.res);
        return opinionData;
      }
      return opinionData;

    case OPINION_LIST :
      /* success */
      opinionData.splice(0, opinionData.length);
      if (action.payload.data === undefined) {
        return state;
      } else if (action.payload.data.resultCode === 'S0000') {
        opinionData.push(action.payload.data.res);
        return opinionData;
      } else if (action.payload.data.resultCode !== 'S0000') {
        opinionData.push(action.payload.data);
        return opinionData;
      }
      return opinionData;
    case REISSUE_ACCESS_TOKEN :
      opinionData.splice(0, opinionData.length);
      if (action.payload.data === undefined) {
        return state;
      } else if (action.payload.data.resultCode === 'S0000') {
        // opinionData.push(action.payload.data.res)
        sessionStorage.setItem('token', action.payload.data.res.accessToken);
        sessionStorage.setItem('refreshToken', action.payload.data.res.refreshToken);
        sessionStorage.setItem('tokenExpireTime', action.payload.data.res.tokenExpireTime);
        return opinionData;
      }
      return opinionData;
    case OPINION_UPDATE :
    case OPINION_DELETE :
      opinionData.splice(0, opinionData.length);
      if (action.payload === undefined) {
        return opinionData;
        /* SUCCESS */
      } else if (action.payload.data.resultCode === 'S0000') {
        opinionData.push(action.payload.data.resultCode);
        return opinionData;
      }
      break;
    case OPINION_FILEINSERT:
    case OPINION_FILEDELETE:
    case OPINION_FILEDOWNLOAD:
      opinionData.splice(0, opinionData.length);
      if (action.payload === undefined) {
        return opinionData;
        /* SUCCESS */
      } else if (action.payload.data.resultCode === 'S0000') {
        opinionData.push(action.payload.data.resultCode);
        return opinionData;
      }
      break;
    default:
      return state;
  }
};

  